<div class="flex relative justify-between items-center">
  <app-icon name="heroMinusMini" (click)="onMinus()" class="text-blue cursor-pointer"></app-icon>

  <div class="absolute bottom-[-6px] left-[39px] font-bold text-xs">
    {{ startSliderValue() }}
  </div>
  <div class="relative" #sliderWrapper>
    <div
      [class]="'triangle'"
      [style]="{ left: triangleLeft() + '%' }"
      (mousedown)="startDrag($event, sliderWrapper)"
      (touchstart)="startDrag($event, sliderWrapper)"
      [matTooltip]="currentValue().toString()"
      matTooltipPosition="above"
      [matTooltipDisabled]="isEnabled() !== 'triangle'"
    >
      @if (isEnabled() === 'triangle') {
        <app-icon size="giant" name="triangle-bottom"></app-icon>
      } @else {
        <app-icon size="giant" class="triangle-inactive" name="triangle-bottom-inactive"></app-icon>
      }
    </div>
    <mat-slider
      [min]="minStart()"
      [max]="maxEnd()"
      [discrete]="showAdditionalTooltips()"
      [class]="isEnabled() !== 'slider' ? 'inactive-slider' : ''"
    >
      <input
        [(ngModel)]="startSliderValue"
        matSliderStartThumb
        (dragEnd)="onValueChange()"
        #matSliderStartThumb />
      <input
        [(ngModel)]="endSliderValue"
        matSliderEndThumb
        (dragEnd)="onValueChange()"
      />
    </mat-slider>
  </div>
  <div class="absolute bottom-[-6px] right-[39px] font-bold text-xs">
    {{ endSliderValue() }}
  </div>

  <app-icon name="heroPlusMini" (click)="onPlus()" class="text-blue cursor-pointer"></app-icon>
</div>
